import React from "react";

const MilestoneUsageModal = ({
  open,
  milestone,
  plans = [],
  templates = [],
  studies = [],
  onClose,
}) => {
  if (!open) return null;

  return (
    <div
      className="modal fade show d-block"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Milestone usage</h5>
            <button type="button" className="btn-close" onClick={onClose} />
          </div>
          <div className="modal-body milestone-usage-plans-modal">
            <p className="milestone-usage-plans-modal__subtitle">
              <strong>{milestone?.Code}</strong>
              {" — "}
              {milestone?.Name}
            </p>

            {plans.length > 0 && (
              <>
                <h6 className="milestone-usage-plans-modal__section-title">
                  Milestone plans ({plans.length})
                </h6>
                <ul className="milestone-usage-plans-modal__list">
                  {plans.map((plan) => (
                    <li key={plan.MilestonePlanId}>
                      <span className="milestone-usage-plans-modal__name">
                        {plan.PlanName}
                      </span>
                      <span className="text-muted">
                        v{plan.VersionNo}
                        {plan.Status ? ` · ${plan.Status}` : ""}
                      </span>
                    </li>
                  ))}
                </ul>
              </>
            )}

            {templates.length > 0 && (
              <>
                <h6 className="milestone-usage-plans-modal__section-title">
                  Templates ({templates.length})
                </h6>
                <ul className="milestone-usage-plans-modal__list">
                  {templates.map((template) => (
                    <li key={template.TemplateId}>
                      <div className="milestone-usage-plans-modal__row-head">
                        <span className="milestone-usage-plans-modal__name">
                          {template.TemplateName}
                        </span>
                        <span
                          className={`milestone-usage-plans-modal__assignment milestone-usage-plans-modal__assignment--${String(
                            template.AssignmentType || "Ad-hoc",
                          )
                            .toLowerCase()
                            .replace(/[^a-z]/g, "")}`}
                        >
                          {template.AssignmentType === "Plan" ? "Plan" : "Ad-hoc"}
                        </span>
                      </div>
                      {template.TemplateCategory ? (
                        <span className="text-muted">{template.TemplateCategory}</span>
                      ) : null}
                    </li>
                  ))}
                </ul>
              </>
            )}

            {studies.length > 0 && (
              <>
                <h6 className="milestone-usage-plans-modal__section-title">
                  Study eISF ({studies.length})
                </h6>
                <ul className="milestone-usage-plans-modal__list">
                  {studies.map((study) => (
                    <li key={study.StudyIdRef}>
                      <span className="milestone-usage-plans-modal__name">
                        {study.StudyName || study.StudyIdRef}
                      </span>
                      <span className="text-muted">
                        {Number(study.PlaceholderCount) || 0} placeholder(s)
                      </span>
                    </li>
                  ))}
                </ul>
              </>
            )}

            {plans.length === 0 && templates.length === 0 && studies.length === 0 && (
              <p className="text-muted mb-0">No usage found.</p>
            )}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-outline-secondary btn-sm"
              onClick={onClose}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MilestoneUsageModal;
